export var CARD_PADDING_HORIZONTAL = 'S200';
export var CARD_SPACING = 'S500';
export var CARD_SPACING_REDUCED = 'S300';